<template>
  <div id="elHeader">
    <div class="box">
      <div class="left">
        <a href="/">
          <img src="@/assets/images/png/logo.png" class="logo" />
        </a>
      </div>
      <div class="right">
        <!-- 刷新页面 -->
        <p class="RefreshPage" @click="reload()">
          <i class="el-icon-refresh-right"></i> <span>刷新页面</span>
        </p>

        <!-- 项目工作看板 -->
        <span> |&nbsp;&nbsp;&nbsp; </span>
        <p class="RefreshPage" @click="largeScreen()">
          <i class="el-icon-monitor"></i> <span>项目工作看板</span>
        </p>

        <span> |&nbsp;&nbsp;&nbsp; </span>
        <a @click="openDialog()" style="color: white;margin-top: 2px">帮助文档</a>

        <span>&nbsp;&nbsp;|&nbsp;</span>
        <!-- 消息提醒 -->
        <el-popover placement="bottom" width="260" trigger="hover">
          <div class="ment">
            <new-info />
          </div>
          <div slot="reference">
            <el-badge :value="$store.state.websocketInfo.taskCount" :max="99" class="item">
              <i class="el-icon-bell"></i>
            </el-badge>
          </div>
        </el-popover>
        <!-- 用户操作 -->
        <el-popover placement="bottom" width="100" trigger="hover">
          <div class="ment">
            <p @click="$store.state.showDialog = true">修改密码</p>
            <p class="logoutStyle" @click="outAdmin">退出</p>
          </div>
          <el-button type="text" slot="reference" class="info">欢迎您！
            {{ $store.state.userInfo ? $store.state.userInfo.nickname : " "
            }}<i class="el-icon-arrow-down"></i></el-button>
        </el-popover>
      </div>
    </div>
    <pdf-dialog ref="pdfDialog" />
  </div>
</template>

<script>
import { getOutAdmin } from "@/network/login.js";
import pdfDialog from "./pdfDialog";

import newInfo from "./new-info.vue"

export default {
  name: "elHeader",
  components: { newInfo, pdfDialog },
  data() {
    return {
    };
  },

  mounted() {
    // let is =
    //   sessionStorage.isTaskInfo || this.$route.path === "/taskList/receiveTask";
    // if (is) return false;

    // getReceiveTaskList().then((res) => {
    //   sessionStorage.isTaskInfo = true;
    //   let [data, num] = ["", 0];
    //   res.data.records.forEach((element) => {
    //     if (element.state == 0) {
    //       let html = `<p style="cursor: pointer;">${num + 1}. ${
    //         element.title
    //       }</p>`;
    //       data += html;
    //       num++;
    //     }
    //   });
    //   if (data === "") return false;

    //   let aaa = this.$notify({
    //     title: `您有${num}条未读任务`,
    //     type: "info",
    //     duration: 0,
    //     dangerouslyUseHTMLString: true,
    //     message: data,
    //     onClick: () => {
    //       this.$router.push({ path: "/taskList/receiveTask" });
    //       closeInfo();
    //     },
    //   });
    //   function closeInfo() {
    //     aaa.close();
    //   }
    // });
  },

  methods: {
    openDialog() {
      this.$refs.pdfDialog.pdfPreviewDialog = true
    },
    largeScreen() {
      this.$router.push({ path: "/zhd/largeScreen" });
    },

    outAdmin() {
      this.$confirm("是否退出登陆？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getOutAdmin()
            .then((res) => {
              if (res.code === 0) {
                localStorage.removeItem("token");
                localStorage.removeItem("routes");
                this.$notify({ type: "success", message: "退出成功！" });
                this.$router.push({ path: "/login" });
                // location.reload();
              } else {
                this.$notfy({ type: "info", message: res.msg });
              }
            })
            .catch((err) => {
              this.$notify.error({ message: "退出失败！" });
            });
        })
        .catch(() => {
          this.$notify({
            type: "info",
            message: "已取消退出",
          });
        });
    },
    reload() {
      location.reload();
    },
  },
};
</script>

<style scoped>
#elHeader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  width: 100%;
  background: #f25f5c;
}

#elHeader .box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 12px 40px;
  height: 60px;
  box-sizing: border-box;

  color: #fff;

  box-shadow: rgba(100, 100, 111, 0.05) 0px 5px 20px 0px;
}

#elHeader .box .left {
  height: 100%;
  cursor: pointer;
}

#elHeader .box .left .logo {
  height: 100%;
  display: block;
}

#elHeader .logoutStyle {
  opacity: 0.8;
  font-size: 15px;
  cursor: pointer;
}

#elHeader .logoutStyle:hover {
  opacity: 1;
}

#elHeader .info {
  color: #fff;
  font-weight: 400;
}

#elHeader .info i {
  margin-left: 8px;
  transition: all 0.6s;
}

#elHeader .info:hover i {
  transform: rotate(180deg);
}

.ment p {
  cursor: pointer;
  line-height: 36px;
  text-indent: 10px;
}

.ment p:hover {
  background: rgb(235, 235, 235);
}

#elHeader .box .right {
  display: flex;
  align-items: center;
  font-size: 14px;
}

#elHeader .box .right .RefreshPage {
  margin-right: 14px;
  cursor: pointer;
}

.RefreshPage i {
  color: #fff;
  font-size: 18px;
  line-height: 20px;
}

.item {
  margin: 0 20px;
  cursor: pointer;
}

.item i {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/osNav/components/elHeader.vue